export default __webpack_public_path__ + "static/media/ReleaseNotes_Content_BrokerNotes2.40800a14.png";